var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.4 16.4",
    style: {
      enableBackground: "new 0 0 16.4 16.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#595757;}\n\t.st1{fill:#2C6CFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.1,3.4C9.7,3.4,9.4,3.7,9.4,4c0,0.2,0,0.4,0.2,0.5S9.8,4.8,10,4.8c3,0.3,5,2.3,5,5.3V15 c-2.8-0.2-5-2.5-5-5.3C10,9.3,9.7,9,9.3,9C8.9,9,8.6,9.3,8.6,9.7c0,3.7,3,6.7,6.7,6.7h0.4c0.4,0,0.7-0.3,0.7-0.7v-5.6 C16.4,6.3,13.9,3.7,10.1,3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.1,9C6.7,9,6.4,9.3,6.4,9.7c0,2.8-2.2,5.1-5,5.3v-4.9c0-3,2-5,5-5.3c0.2,0,0.3-0.1,0.5-0.2C7,4.4,7,4.2,7,4 c0-0.4-0.4-0.7-0.7-0.6C2.5,3.7,0,6.3,0,10.1v5.6c0,0.4,0.3,0.7,0.7,0.7h0.4c3.7,0,6.7-3,6.7-6.7C7.8,9.3,7.4,9,7.1,9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.5,7L5.7,6.2c-0.3-0.3-0.7-0.3-1,0C4.6,6.3,4.5,6.5,4.5,6.7S4.6,7,4.7,7.2l0.6,0.6C5,7.8,4.7,7.9,4.4,7.9 c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7c1.6,0,3-0.8,3.8-2.1c0.8,1.3,2.2,2.1,3.8,2.1c0.4,0,0.7-0.3,0.7-0.7 c0-0.4-0.3-0.7-0.7-0.7c-0.3,0-0.6-0.1-0.8-0.1l0.6-0.6c0.1-0.1,0.2-0.3,0.2-0.5s-0.1-0.4-0.2-0.5c-0.3-0.3-0.7-0.3-1,0L9.9,7 c-0.6-0.6-1-1.4-1-2.2V0.7C8.9,0.3,8.6,0,8.2,0S7.5,0.3,7.5,0.7v4.1C7.5,5.7,7.1,6.5,6.5,7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/폐호흡.4acf9cfc527550cea38f3ad9f6f70fba.svg";
export { ForwardRef as ReactComponent };